import React, { useCallback } from 'react';
import { Image, StyleSheet, Text, View, TouchableOpacity } from 'react-native';
import Colors from '../../constants/Colors';
import FontStyles from '../../constants/FontStyle';
import StyledIcon from '../StyledIcon';
import { CartContext } from '../../contexts/cart/Store';
import { useFocusEffect, useNavigation, useRoute } from '@react-navigation/native';

let showFloatingButtonTimer: any = null

const CartFloatingButton: React.FC = () => {
    const route = useRoute();
    const navigation = useNavigation();
    const [cart_state] = React.useContext(CartContext)
    const [count, setCount] = React.useState(null)
    const [visible, setVisibility] = React.useState(false)

    const gotoCart = () => {
        navigation.navigate('Cart')
    }

    React.useEffect(() => {
        //
        setCount((prev: any) => {
            if (
                (prev && prev < cart_state?.order_group_items?.length)
            ) {
                setVisibility(true)
                showFloatingButtonTimer = setTimeout(() => {
                    setVisibility(false)
                }, 3000)
                return cart_state?.order_group_items?.length
            }

            if (cart_state.order_group_items.length) {
                return cart_state.order_group_items.length
            }
        })
        return () => {
            clearTimeout(showFloatingButtonTimer)
        }
    }, [cart_state.order_group_items])

    // useFocusEffect(
    //     useCallback(() => {
    //         console.log(route?.state?.routes[0].name)
    //         return () => {}
    //     }, [])
    // )

    return <>
        {
            count
                ? <TouchableOpacity
                    style={[styles.container]}
                    activeOpacity={1}
                    onPressIn={gotoCart}
                >
                    {
                        visible
                            ? <View style={[styles.alertContainer]}>
                                <View style={[styles.alertBox]}>
                                    <StyledIcon
                                        iconName="ios-checkmark-circle-outline"
                                        iconColor={Colors.whiteColor}
                                        iconOnly
                                        size={18}
                                    />
                                    <Text style={[styles.alertBoxText]}>Product added to cart</Text>
                                </View>
                            </View>
                            : null
                    }

                    <View style={[styles.buttonContainer]}>
                        <Image
                            source={require('../../assets/images/main/bag.png')}
                            style={[styles.buttonIcon]}
                        />
                        <Text style={[styles.buttonCounter]}>{count}</Text>
                    </View>
                </TouchableOpacity>
                : null
        }
    </>
}

export default CartFloatingButton;

const styles = StyleSheet.create({
    container: {
        flex: 1,
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'flex-end',

        // left: 0,
        right: 0,
        bottom: 70,
        minHeight: 64,

        paddingHorizontal: 20,

        width: 'auto',
        maxWidth: '100%',

        position: 'absolute',
        zIndex: 999,
    },
    buttonContainer: {
        width: 64,
        height: 64,
        borderRadius: 64,
        position: 'absolute',
        backgroundColor: Colors.darkerTintColor,
        zIndex: 1,
        alignItems: 'center',
        justifyContent: 'center',
    },
    buttonIcon: {
        width: 22.92,
        height: 25.38,
    },
    buttonCounter: {
        position: 'absolute',
        top: 0,
        right: 0,
        borderRadius: 20,
        paddingVertical: 4,
        paddingHorizontal: 6,
        minWidth: 20,
        backgroundColor: Colors.dangerText,
        ...FontStyles.semibold,
        ...FontStyles.size13,
        ...FontStyles.lh16,
        ...FontStyles.white,
        marginRight: -4,
        // alignItems: 'center',
        textAlign: 'center',
    },
    alertContainer: {
        paddingRight: 64 / 2,
        width: '100%',
        maxWidth: '100%',
    },
    alertBox: {
        flexDirection: 'row',
        alignItems: 'center',
        width: 'auto',
        paddingRight: (64 / 2) + 12,
        paddingLeft: 12,
        paddingVertical: 9,
        borderRadius: 6,
        backgroundColor: Colors.darkerTintColor,
    },
    alertBoxText: {
        ...FontStyles.medium,
        ...FontStyles.size13,
        ...FontStyles.lh26,
        ...FontStyles.white,
        alignSelf: 'center',
        marginLeft: 10,
    },
})